import React from 'react';
import AltIso from 'alt/utils/AltIso';

import connectToStores from 'alt/utils/connectToStores';

import ShiftPositionsForm from '../forms/ShiftPositionsForm'

import PositionStore from '../stores/PositionStore';
import ShiftStore from '../stores/ShiftStore';
import CandidateStore from '../stores/CandidateStore';
import ShiftActions from '../actions/ShiftActions';

@AltIso.define((props) => {
    return Promise.all([
        PositionStore.getPositions()
    ]);
})
@connectToStores
class CreateShiftStep2 extends React.Component {

    static getPropsFromStores() {
        return {
            positionStore: PositionStore.getState(),
            shiftStore: ShiftStore.getState(),
            candidateStore: CandidateStore.getState()
        };
    }

    static getStores() {
        return [PositionStore, ShiftStore, CandidateStore];
    }

    componentDidMount() {
        const shiftData = this.props.shiftStore.stepTwoData;
        CandidateStore.getPotentialCandidates(shiftData.position, shiftData.rate);
    }

    onChange(value, path) {
        if (path.indexOf('position') > -1 || path.indexOf('rate') > -1) {
            CandidateStore.getPotentialCandidates(value.position, value.rate);
        }

        this.props.onChange(value, path);
    }

    save(e) {
        e.preventDefault();

        const data = this.refs.form.getValue();
        const errors = this.refs.form.validate(true).errors;
        if (errors) {
            ShiftActions.mergeErrorsIntoState(errors);
        }
        if (data) {
            // Cache data and proceed to next step
            ShiftActions.saveStepTwoData(data);
            this.props.changeStep.call(this, 3, true);
        }
    }

    back(e) {
        e.preventDefault();
        this.props.changeStep.call(this, 1);
    }

    render () {
        return (
            <div className="create-shift-step-content create-shift-step2">
                <ShiftPositionsForm
                    onChange={this.onChange.bind(this)}
                    initialFormData={this.props.shiftStore.stepTwoData}
                    errors={this.props.shiftStore.createError}
                    potentialCandidates={this.props.candidateStore.potentialCandidates}
                    ref="form"
                    positions={this.props.positionStore.positions} />

                <div className="position-form-buttons">
                    <button className="btn btn-small btn-green btn-continue" onClick={this.save.bind(this)}>Continue</button>
                    <button className="btn-transparent btn-back" onClick={this.back.bind(this)}>BACK</button>
                </div>
            </div>
        );
    }
}

export default CreateShiftStep2;



/** WEBPACK FOOTER **
 ** ./app/src/components/CreateShiftStep2.js
 **/